import { gql } from '@apollo/client';

export type GetCSVFileType = {
  file: {
    id: string;
    name: string;
    rowCount: number;
    columns: {
      id: string;
      index: number;
      name: string;
      type: string;
    }[];
  };
};

export const GET_CSVFILE = gql`
  query GetCSVFile($input: CSVFileInput!) {
    file: getCSVFile(input: $input) {
      id
      name
      rowCount
      columns {
        id
        index
        name
        type
      }
    }
  }
`;
